import { Provider } from '@angular/core';
import { AuthConfig } from '../../models/auth-config/auth-config.model';
import { AUTH_CONFIG } from './auth-config.token';

export const provideAuthConfig = (config?: Partial<AuthConfig>): Provider[] => [
    {
        provide: AUTH_CONFIG,
        useValue: config ?? {},
    },
];
